/** @jsx jsx */
import { jsx } from "@emotion/core"
import { Theme } from "../types"
import { SerializedStyles } from "@emotion/core"
import { Image, Placeholder, Transformation } from "cloudinary-react"

type Props = {
    height: string
    width: string
    publicId: string
    testId?: string
    cssStyle?: (theme: Theme) => SerializedStyles
}

function ImageLoader(props: Props) {
    return (
        <Image
            publicId={props.publicId}
            crop="scale"
            loading="lazy"
            css={props.cssStyle}
            data-testid={props.testId}
        >
            <Placeholder type="vectorize" />
            <Transformation
                height={props.height}
                width={props.width}
                crop="fit"
                radius="10"
                quality="auto"
                fetchFormat="auto"
                dpr="auto"
            />
        </Image>
    )
}

export default ImageLoader
